const AddInformationModel = function () {
    const name = 'AddInformation';
    return {
        name,
        state: {
            condition: {
                title: '',
                summary: '',
                content: '',
                author: '',
                status: '',
                appid: '',
                id:'',
            },
            list: [],
            page: {
                pageSize: 30,
                current: 1,
                total: 0,
            }
        },
        selectors: (state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition: () => currentState.condition,
                getList: () => currentState.list,
                getPage: () => currentState.page,
            };
            return selectors;
        },
        api: {},
        actions: {
            changeCondition: (key, value) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_ADD_INFORMATION_CONDITION',
                    key,
                    value
                })
            },
            changeList: (list) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_ADD_INFORMATION_LIST',
                    list
                })
            },
            changePage: (page) => (dispatch, getState) => {
                dispatch({
                    type: 'CHANGE_ADD_INFORMATION_PAGE',
                    page
                })
            }
        },
        reducers: {
            condition: (state = AddInformationModel.state.condition, action) => {
                if (action.type === 'CHANGE_ADD_INFORMATION_CONDITION') {
                    const {key, value} = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page: (state = AddInformationModel.state.page, action) => {
                if (action.type === 'CHANGE_ADD_INFORMATION_PAGE') {
                    return Object.assign({}, state, action.page);
                }
                return state;
            },
            list: (state = AddInformationModel.state.list, action) => {
                if (action.type === 'CHANGE_ADD_INFORMATION_LIST') {
                    return [...action.list];
                };
                return state;
            }
        }
    }
}();

export default AddInformationModel;


// WEBPACK FOOTER //
// ./src/models/AddInformationModel.js